<template>
    <div>
        <MainLayout>
            <h1>{{ $t('todo_title') }}</h1>
            <input v-model="new_todo.name" :placeholder="$t('todo_hint_name')">
            <textarea v-model="new_todo.todo" :placeholder="$t('todo_hint_task')"></textarea>
            <button v-on:click="addTodo" :title="$t('domain_hint_add')">{{ $t('general_add') }}</button>
            <table class="table">
                <thead>
                <tr>
                    <th>{{ $t('general_id') }}</th>
                    <th>{{ $t('general_name') }}</th>
                    <th>{{ $t('todo_task') }}</th>
                    <th>{{ $t('general_option') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(todo,index) in todos" v-bind:key="index">
                    <td>{{ todo.id }}</td>
                    <td v-on:dblclick="goToEdit(todo.id,true)">
                        <span v-if="edit[todo.id]!==true">{{ todo.name }}</span>
                        <input v-else-if="edit[todo.id]===true" v-on:blur="editTodo(todo.id,todo)" :ref="'input_edit_'+todo.id"  v-model="todo.name">
                    </td>
                    <td v-on:dblclick="goToEdit(todo.id,true)">
                        <span class="nl2br" v-if="edit[todo.id]!==true">{{ todo.todo }}</span>
                        <textarea v-on:blur="editTodo(todo.id,todo)" :ref="'input_edit_'+todo.id" v-else-if="edit[todo.id]===true" v-model="todo.todo"></textarea>
                    </td>
                    <td>
                        <button v-on:click="goToEdit(todo.id,true)">{{ $t('general_edit') }}</button>
                        <button v-on:click="deleteTodo(todo.id)">{{ $t('general_delete') }}</button>
                    </td>
                </tr>
                </tbody>
                <div class="pagination">
                    <Pagination route_name="todo_list" :page="page" :on_page="on_page" :total_item="total_item"/>
                </div>
            </table>
        </MainLayout>
    </div>
</template>

<script>
    import MainLayout from '../components/MainLayout.vue';
    import {bus} from '../main'
    import config from '../config'
    import Pagination from '../components/Pagination';

    export default {
        name: 'ToDoList',
        components: {
            MainLayout,
            Pagination,
        },
        data:function(){
            return {
                todos:[],
                new_todo:{},
                edit:[],
                on_page:15,
                total_item:0,
                page:1,
            }
        },
        methods: {
            loadTodos: function() {
                let offset=((this.on_page * this.page)-this.on_page);
                this.axios.get(config.API_URL+'todos?offset='+offset+'&limit='+this.on_page).then(response => {
                    this.todos = response.data.data;
                    this.total_item = parseInt(response.data.total);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            addTodo(){
                this.axios.post(config.API_URL+'todos',new URLSearchParams(
                    this.new_todo
                )).then(response => {
                    this.new_todo.name = '';
                    this.new_todo.todo = '';
                    this.loadTodos();
                    bus.$emit('alert-success',response.data.message);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            goToEdit(id){
                this.edit[id]=true;
                this.$forceUpdate();
            },
            editTodo(id , todo){
                this.axios.put(config.API_URL+'todos/'+id, new URLSearchParams(
                    todo
                )).then(response => {
                    this.edit[id]=false;
                    this.$forceUpdate();
                    bus.$emit('alert-success',response.data.message);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            deleteTodo:function(id){
                if(confirm(this.$t('general_delete_question'))) {
                    this.axios.delete(config.API_URL + 'todos/' + id).then(response => {
                        this.loadTodos();
                        bus.$emit('alert-success', response.data.message);
                    }).catch(error => {
                        if (error.response.status === 401) {
                            bus.$emit('logout', true);
                        } else {
                            bus.$emit('alert-error', error.response.data.message);
                        }
                    });
                }
            },
        },
        mounted() {
            if(this.$route.params.page) this.page = parseInt(this.$route.params.page); else this.page = 1;
            this.loadTodos();
        },
        beforeRouteUpdate(to,from,next){
            if(to.params.page) this.page = parseInt(to.params.page); else this.page = 1;
            this.loadTodos();
            next();
        },
    }
</script>

<style scoped>
    .table{
        width: 100%;
    }
    .table th{
        text-align: left;
    }
    .table tr:hover{
        background-color: lightgray;
    }
</style>
